<template>
  <vuestic-sidebar class="sidebar" :hidden="isOpen">
    <!-- SIDEBAR MENU -->
    <template slot="menu">
      <sidebar-link
        :to="{ name: 'dashboard' }">
        <span slot="title">
          <span
            class="fa fa-car"></span>
          <span class="titulo">Repuestos Miranda ERP</span>
        </span>
      </sidebar-link>
      <div v-for="modulo in modulos" :class="{hidden: isHidden(modulo.perms)}">
        <sidebar-link-group>
                <span slot="title">
                    <span :class="modulo.icon"></span>
                    <span class="titulos">{{modulo.title}}</span>
                </span>
          <div v-for="sub in modulo.subModulos">
            <sidebar-link :to="sub.ruta">
                      <span slot="title">
                        <span class="sub">{{sub.subtitulo}}</span>
                      </span>
            </sidebar-link>

          </div>
        </sidebar-link-group>
      </div>
    </template>
  </vuestic-sidebar>
</template>

<script>

  import VuesticSidebar
    from '../../../vuestic-theme/vuestic-components/vuestic-sidebar/VuesticSidebar'
  import SidebarLink from './components/SidebarLink'
  import SidebarLinkGroup from './components/SidebarLinkGroup'
  import {havePermission} from "../../../util/utils";
  import modulos from './modulos'

  export default {
    name: 'app-sidebar',
    components: {
      VuesticSidebar,
      SidebarLink,
      SidebarLinkGroup,
    },
    data() {
      return {
        isHidden: function (perms) {
          const d = havePermission(perms)
          return !d;
        },
        modulos
      }
    },
    props: {
      isOpen: {
        type: Boolean,
        required: false,
      },
    }
  }

</script>

<style scoped lang="scss">
  .hidden {
    display: none;
  }

  .titulos {
    margin-left: 10px;
    font-size: 17px;
  }

  .titulo {
    margin-left: 10px;
    font-size: 19px;
    font-weight: bold;
  }

  .sub {
    font-size: 13px;
    font-weight: bolder;
  }
  .sidebar-link {
  .sidebar-link__router-link {
    position: relative;
    height: $sidebar-link-height;
    padding-left: $sidebar-link-pl;
    display: flex;
    flex-direction: row;
    align-items: center;
    cursor: pointer;
    text-decoration: none;
  &.router-link-active,
  &:hover {
     color: $white;
     background-color: $sidebar-link-active-bg;
  .sidebar-menu-item-icon,
  .expand-icon {
    color: $white;
  }
  }
  &:hover {
     background-color: $hover-black;
   }
  .sidebar-menu-item-icon {
    font-size: $sidebar-menu-item-icon-size;
    color: $vue-green;
    margin-right: 14px;
  &.fa-dashboard {
     /* Temp fix */
     position: relative;
     top: -2px;
   }
  }
  }

  a {
    color: $white;
    text-decoration: none;
  }
  }

  @media print {
    .sidebar {
      display: none !important;
    }
  }
</style>

